<template>
    <el-dialog title="功能授权配置" :visible.sync="isShow" @close="close">
        <el-tree :data="data" ref="tree" show-checkbox node-key="id" :default-checked-keys="propsKey"
            :props="defaultProps"></el-tree>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="sure">确 定</el-button>
        </div>
    </el-dialog>
</template>
  
<script>
export default {
    //propsKey   数据回显
    //treeMenus    树状结构
    //name     修改defalutProps.label的值

    props: ['propsKey', 'treeMenus', 'name'],
    data() {
        return {
            data: [],
            defaultProps: {
                label: 'menuName',
                children: 'listTreeMenus',
            },
            isShow: false,
        }
    },
    created() {
        
    },
    methods: {
        close() {
            this.data = []
            this.isShow = false
        },
        open() {
            this.data = this.treeMenus
            this.isShow = true
            this.defaultProps.label = this.name
        },
        sure() {
            let arr = this.$refs.tree.getCheckedKeys()
            this.$emit('selectModules', arr)
            this.close()
        }
    }
}
</script>
  
<style></style>